import { Link } from "react-router-dom";
import { RiUserSettingsLine } from "react-icons/ri";
import UserPermissionUpdateForm from "./form";

function UserPermissionUpdate() {
  return (
    <>
      <div>
        <ul
          className="flex flex-col flex-wrap justify-center pl-0 mt-2 mb-1 list-none border-b-0 md:flex-row"
          role="tablist"
          data-te-nav-ref
        >
          <li role="presentation">
            <a
              href="#tabs-sync-product"
              className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-600 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-violet data-[te-nav-active]:text-violet dark:text-neutral-600 dark:hover:bg-transparent data-[te-nav-active]:border-neutral-600 data-[te-nav-active]:text-neutral-600"
              data-te-toggle="pill"
              data-te-target="#tabs-sync-product"
              data-te-nav-active
              role="tab"
              aria-controls="tabs-sync-product"
              aria-selected="true"
            >
              <div className="flex items-center gap-2">
                <RiUserSettingsLine size={25} />
                <span className="">User Permissions</span>
              </div>
            </a>
          </li>
        </ul>

        <div className="px-6 mb-6">
          <div className="page-container-title">
            <div className="grid grid-cols-5 gap-0.5 md:gap-1 items-center sm:page-container-only-button">
              <p className="col-start-1 col-end-3 mr-2 text-lg font-bold">
                Edit Permission
              </p>
              <Link
                to={`/userPermissions`}
                className={
                  " text-sky-400 hover:text-sky-600 text-xs col-start-3 col-end-5"
                }
              >
                {"<<"} Back to permission page
              </Link>
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-center">
          <UserPermissionUpdateForm />
        </div>
      </div>
    </>
  );
}
export default UserPermissionUpdate;
